import * as React from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import styled, { css } from 'styled-components';
import { Page } from '../../components/Page/Page';
import { useLayoutContext } from '../../utils/customHooks/LayoutContext';
import { CreateCecMessage } from '../CreateCecMessage/CreateCecMessage';
import { CreateCecMessageOptions } from '../CreateCecMessage/CreateCecMessageOptions';
import { CreateCecMessageSummary } from '../CreateCecMessage/CreateCecMessageSummary';
import { CreateCecMessageCtxProvider } from './CreateCecMessageContext';
import { RecipientGroups } from '../RecipientGroups/RecipientGroups';
import { recipientGroupsCss } from '../RecipientGroups/RecipientGroups.styles';

const SPage = styled(Page)<{
  $chatInput?: boolean;
  $isOptions?: boolean;
  $isRecipientGroups?: boolean;
}>`
  padding: 1.375rem 0 1.375rem 0;
  /* to make only the list overflow */
  position: relative;
  ${props =>
    props.$chatInput &&
    css`
      min-height: calc(100vh - 4.81rem);
    `}
  ${props =>
    props.$isOptions &&
    css`
      padding: 0 0 1.375rem 0;
    `}

    ${props => props.$isRecipientGroups && recipientGroupsCss}
  height: 100%;
  /* min-height: 100; */
`;

export const CreateCecMessageContainer = () => {
  const [isChatInput, setIsChatInput] = React.useState<boolean>(false);
  const [isOptionsPage, setIsOptionsPage] = React.useState<boolean>(false);
  const [isRecipientGroupsPage, setIsRecipientGroupPages] = React.useState<boolean>(false);

  const { pathname } = useLocation();
  const { setTabsState, toggleTabBarVisibility } = useLayoutContext();

  React.useEffect(() => {
    if (pathname === '/createCecMessage/summary') {
      toggleTabBarVisibility();
      setIsChatInput(true);
    } else {
      setTabsState(true);
      setIsChatInput(false);
    }
    if (pathname === '/createCecMessage/options') {
      setIsOptionsPage(true);
    } else {
      setIsOptionsPage(false);
    }
    if (pathname === '/createCecMessage/recipient-contacts') {
      setIsRecipientGroupPages(true);
    } else {
      setIsRecipientGroupPages(false);
    }
  }, [pathname]);

  return (
    <SPage
      $chatInput={isChatInput}
      $isOptions={isOptionsPage}
      $isRecipientGroups={isRecipientGroupsPage}
    >
      <CreateCecMessageCtxProvider>
        <Routes>
          <Route path="/" element={<CreateCecMessage />} />
          <Route path="options" element={<CreateCecMessageOptions />} />
          <Route path="summary" element={<CreateCecMessageSummary />} />
          <Route path="recipient-contacts" element={<RecipientGroups havePrebuiltLayout />} />
        </Routes>
      </CreateCecMessageCtxProvider>
    </SPage>
  );
};
